import React from "react";
import "./Thankyou.css";
import { FaDownload } from "react-icons/fa";
import Header from "../header/header";
import Footer from "../footer/footer";

function RegistrationThankYouPage() {
  return (
    <div>
      <Header />
      <div className="thanks-container">
        <div className="thank-you-image">
          <span>Success!</span>
        </div>

        <div className="content-card">
          <h1>Thank you for registering with AstroBhagya!</h1>

          <p>
            Your profile is under review. Once verified, you'll receive an OTP
            via email to log in. We'll share your onboarding details shortly.
          </p>

          <h2>Welcome to the journey!</h2>
          <button
            className="download-button"
            onClick={() => window.open("https://play.google.com/store/apps/details?id=com.astrobhagyap", "_blank")}
          >
            <FaDownload className="download-icon" />
            <span>Download the app</span>
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default RegistrationThankYouPage;
